import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelsCommand, } from "../commands/ListChannelsCommand";
export const paginateListChannels = createPaginator(ChimeSDKMessagingClient, ListChannelsCommand, "NextToken", "NextToken", "MaxResults");
